import React, { useContext } from 'react';
import { arrayOf, bool, number, object } from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import ListViewListings from '@fiverr-private/gig_listings/src/entries/ListViewListings';
import { setAllCollections } from '../../../../../../../../store/collections/actions';
import useGigListing from '../../../../../../../../../../shared/hooks/useGigListing';
import { pageContext } from '../../../../../../../../shared/gigListings/constants';
import { SourceComponentType } from '../../../../../../../../../../shared/types/sourceComponentType';
import SharedContext from '../../../../../../../../../../shared/context';
import { LAZY_LOAD_OFFSET } from './constants';

import './style.scss';

const SellerGigs = ({ gigs, loading, total, collections }) => {
    const { rollouts } = useContext(SharedContext);
    const { contextEnrichment, collectProps } = useGigListing({
        gigs,
        pageContext,
        sourceComponent: SourceComponentType.AVAILABLE_SERVICES,
        collections,
        onUpdateCollections: setAllCollections,
    });

    if (isEmpty(gigs) && !loading) {
        return null;
    }

    return (
        <aside className="seller-gigs">
            <ListViewListings
                gigs={gigs}
                lazyLoadOffset={LAZY_LOAD_OFFSET}
                isLoading={loading}
                size={total}
                showFooter={false}
                rollouts={rollouts}
                collectProps={collectProps}
                {...contextEnrichment}
            />
        </aside>
    );
};

SellerGigs.propTypes = {
    gigs: arrayOf(object),
    collections: arrayOf(object),
    loading: bool,
    total: number,
};

const mapDispatchToProps = { setAllCollections };

const mapStateToProps = ({ collections }) => ({ collections });

export { SellerGigs };
export default connect(mapStateToProps, mapDispatchToProps)(SellerGigs);
